export default {
  getLeadGenQuestions: (state) => {
    return state.leadGenQuestions
  },
  getAnswers: (state) => {
    return state.answers
  },
  getTotalQuestions: (state) => {
    return state.leadGenQuestions?.length || 0
  },
  getOrgGuid: (state) => {
    return state.orgGuid
  },
  getOrgType: (state) => {
    return state.orgType
  },
  getSettings: (state) => {
    return state.settings
  },
  getLoanOfficerTitle: (state) => {
    return state.settings.loanOfficerTitle
  },
  getLandingPageTitle: (state) => {
    return state.settings.landingPageTitle
  },
  getAnswer: (state) => (questionKey) => {
    return state.answers.find(answer => answer.question === questionKey)?.answer
  },
  getCurrentQuestionIndex: (state) => {
    return state.currentQuestionIndex
  },
  isInLeadGenForm: (state) => {
    return state.leadGenQuestions && state.leadGenQuestions.length > 0
  }
}
